<template>
  <IonItemSliding>
    <IonItem lines="none">
      <IonLabel>
        <div class="flex items-center text-gray-500 text-xs flex-nowrap overflow-hidden">
          <div class="font-bold text-gray-700 truncate">{{ comment.userId }}</div>
          <div class="size-1 rounded-full bg-gray-500 mx-2"></div>
          <div class="text-nowrap">{{ formatTimeAgo(comment.timestamp) }}</div>
        </div>
        <div class="text-gray-700 text-wrap">{{ comment.comment }}</div>
      </IonLabel>
    </IonItem>
    <IonItemOptions slot="end" v-if="comment.userId && comment.userId === auth.user?._id">
      <IonItemOption @click="$emit('deleteClicked')" color="danger">
        <i class="icon-trash-2"></i>
      </IonItemOption>
    </IonItemOptions>
  </IonItemSliding>
</template>

<script setup lang="ts">
import { useAuth } from '@/stores/auth.store';
import { IonItem, IonItemOption, IonItemOptions, IonItemSliding, IonLabel } from '@ionic/vue';
import { IComment } from '@ncss/models';
import { formatTimeAgo } from '@vueuse/core';

const auth = useAuth();

defineProps<{
  comment: IComment;
}>();

defineEmits<{
  (e: 'deleteClicked'): void;
}>();
</script>

<style scoped></style>
